import { GameId, ProductContent } from '@common'

import { useTranslatable } from '@/localization/useTranslatable'

import { brawlHyperChargeAsset } from '../../brawlstars/bundle/helpers'
import { DisplayAsset } from '../assetRendering/DisplayAsset'
import { HyperchargeAsset } from '../card/BrawlCardProduct'

interface Props {
  game: GameId
  item: ProductContent
}

export const ProductItemImage = ({ game, item }: Props) => {
  const translatable = useTranslatable()

  const brawl = game === 'brawlstars'
  const isBrawlHypercharge = brawl && brawlHyperChargeAsset(item.product.id)

  if (isBrawlHypercharge) {
    return <HyperchargeAsset title={translatable(item.product.title)} assetId={item.product.id} />
  }

  return <DisplayAsset content={item} preferAnimated={game === 'clashroyale'} gameId={game} />
}
